import axios, {
    type AxiosInstance,
    type AxiosRequestConfig,
  } from 'axios'

/** axios 轻量封装，统一默认头与“直接返回 response.data”行为。 */
export default class Request {
    private instance: AxiosInstance

    /**
     * 创建请求实例并注册统一响应拦截器。
     * @param option axios 实例配置，会覆盖默认超时和请求头。
     */
    constructor(option?: AxiosRequestConfig) {
        const defaultOptions: AxiosRequestConfig = {
            timeout: 10000,
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/octet-stream',
            },
        }
        this.instance = axios.create({ ...defaultOptions, ...option })
        this.instance.interceptors.response.use(
            (response) => response.data,
            (error) => Promise.reject(error),
        )
    }

    /**
     * 发起 GET 请求。
     * @param url 请求地址，可为相对 path 或完整 URL。
     * @param config axios 请求配置。
     * @returns response.data。
     */
    get(url: string, config?: AxiosRequestConfig) {
        return this.instance.get(url, config)
    }

    /**
     * 发起 PUT 请求。
     * @param url 请求地址，可为相对 path 或完整 URL。
     * @param data 请求体。
     * @param config axios 请求配置。
     * @returns response.data。
     */
    put(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<unknown> {
        return this.instance.put(url, data, config)
    }
}